import { ListFilters, listFilterQuery } from "../types/listFilters";
import apiClient from "./apiClient";
import { Order, OrdersApiResponse, OrderDetailApiResponse } from "../types/order";
import { toLegacyListResponse } from "../utils/normalizePaginatedResponse";

const ORDERS_PATH = "shopforme";

export const getOrders = async (
  page = 1,
  limit = 10,
  search = "",       // New
  status = "",
  filters: ListFilters = {}
): Promise<OrdersApiResponse> => {
  try {
    const params: Record<string, string | number | boolean> = { page, limit, ...listFilterQuery(filters, ["startDate", "endDate", "userId"]) };
    if (search) params.search = search;
    if (status) params.status = status;

    const response = await apiClient.get(ORDERS_PATH, { params });
    return toLegacyListResponse<Order, "allOrders">(response.data, "allOrders");
  } catch (error) {

    throw error;
  }
};

export const getOrderById = async (orderId: string): Promise<OrderDetailApiResponse> => {
  try {
    const response = await apiClient.get<OrderDetailApiResponse>(`${ORDERS_PATH}/${orderId}`);
    return response.data;
  } catch (error) {

    throw error;
  }
};

export const updateOrderStatus = async (shopId: string, newStatus: string): Promise<void> => {
  try {
    await apiClient.patch(`${ORDERS_PATH}/update-status`, { shopId, newStatus: newStatus.toLowerCase() });
  } catch (error) {

    throw error;
  }
};

export const updateCartItemPrice = async (
  itemId: string,
  amount: number
): Promise<void> => {
  try {
    await apiClient.patch(`${ORDERS_PATH}/item/${itemId}/price`, { amount });
  } catch (error) {

    throw error;
  }
};